// extracted by mini-css-extract-plugin
module.exports = {"user":"lxHF09Op","empty":"x3Ym2igg","more":"dXCQS0gb","icon":"_R33bXF4","tab":"CooN1kFF","num":"Cf3fV6_2"};